export enum WxCustomerActionTypes {
  API_RESPONSE_SUCCESS = '@@wxCustomer/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR = '@@wxCustomer/API_RESPONSE_ERROR',

  LIST_WXCUSTOMERS = '@@wxCustomer/LIST_WXCUSTOMERS',

  RESET = '@@wxCustomer/RESET',
}